/**
 * @ngdoc controller
 * @name ce-app:ModalControllerCtrl
 *
 * @description
 *
 * @requires $scope
 * */
/* @ngInject */
export default function DistributorPricingModalController($scope, $uibModalInstance, CurrencyFormatterService, __env, distributor) {
    $scope.distributor = distributor;
    $scope.baseUrl = `/${__env.baseUrl}`.replace(/\/+$/, ''); // remove trailing slash

    $scope.dismissModal = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.outputPrice = function (currencyCode, price) {
        // This is a hacky solution. It just checks if it's USD and puts a dollar sign. TODO We'll want to accommodate other countries too.
        const currency = CurrencyFormatterService.getCurrencySymbol(currencyCode);
        return currency + price;
    };
}
